import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CSSPlugin } from 'gsap/CSSPlugin'

//const { $ } = window
//const $body = $(document.body)

export default {
	init() {
		// all translate y values
		// image 1 (125 to -27.5)
		// image 2 (0 to 47.5)
		// image 3 (140 to -140)
		// image 4 (220 to -220)
		// image 5 (-9 to 1.5)
		gsap.timeline({
			defaults: {
				autoAlpha: 1,
				duration: 0.35,
				opacity: 0,
				ease: 'power1.out',
				visibility: 'visible',
				opacity: 1,
			},
			onComplete() {
				ScrollTrigger.create({
					trigger: $('.hero-stats'),
					start: 'center bottom',
					onEnter: () => {
						$('.hero-stat-quantity .data-count').each(function () {
							$(this).css('visibility', 'visible')
							let $this = $(this)
							let countTo = $this.attr('data-count')
							let orig = $this.next().text()
							//console.log(orig);
							//orig = this.querySelector('.data-original').innerText;
							//console.log(orig);

							$({ countNum: $this.text() }).animate(
								{
									countNum: countTo,
								},
								{
									duration: 1000,
									easing: 'linear',
									step() {
										if (isNaN(Math.floor(this.countNum))) {
											$this.text('0')
										} else {
											$this.text(Math.floor(this.countNum))
										}
									},
									complete() {
										//$this.text = '';
										$this.html(orig)
									},
								}
							)
						})
					},
				})
			},
		})

		document.addEventListener('DOMContentLoaded', function () {
			let isMobile = window.matchMedia('(max-width: 767px)').matches

			if (document.querySelector('.image1')) {
				basicScroll
					.create({
						elem: document.querySelector('.image1'),
						from: 'bottom-bottom',
						to: 'top-top',
						direct: true,
						props: {
							'--translateY': {
								from: isMobile ? 125 / 4 + 'px' : '125px',
								to: isMobile ? -27.5 / 4 + 'px' : '-27.5px',
							},
						},
					})
					.start()
			}
			if (document.querySelector('.image2')) {
				basicScroll
					.create({
						elem: document.querySelector('.image2'),
						from: 'bottom-bottom',
						to: 'top-top',
						direct: true,
						props: {
							'--translateY': {
								from: 0,
								to: isMobile ? 47.5 / 4 + 'px' : '-47.5px',
							},
						},
					})
					.start()
			}

			if (document.querySelector('.image3')) {
				basicScroll
					.create({
						elem: document.querySelector('.image3'),
						from: 'bottom-bottom',
						to: 'top-top',
						direct: true,
						props: {
							'--translateY': {
								from: isMobile ? 25 + 'px' : '80px',
								to: isMobile ? -25 + 'px' : '-80px',
							},
						},
					})
					.start()
			}

			if (document.querySelector('.image4')) {
				basicScroll
					.create({
						elem: document.querySelector('.image4'),
						from: 'bottom-bottom',
						to: 'top-top',
						direct: true,
						props: {
							'--translateY': {
								from: isMobile ? 20 + 'px' : '50px',
								to: isMobile ? -20 + 'px' : '-50px',
							},
						},
					})
					.start()
			}

			if (document.querySelector('.image5')) {
				basicScroll
					.create({
						elem: document.querySelector('.image5'),
						from: 'bottom-bottom',
						to: 'top-top',
						direct: true,
						props: {
							'--translateY': {
								from: isMobile ? -9 / 4 + 'px' : '-9px',
								to: isMobile ? -1.5 / 4 + 'px' : '1.5px',
							},
						},
					})
					.start()
			}
			if (document.getElementById('video-video')) {
				document.getElementById('video-video').play()
			}

			/*			const instance2 = basicScroll.create({
				elem: document.querySelector('.image2'),
				from: 'bottom-bottom',
				to: 'top-top',
				props: {
					'--translateY': {
						from: '0',
						to: '47.5px'
					}
				}
			});
			instance.start();
			instance2.start(); */
		})
	},
	finalize() {},
}
